<template>
  <div class="lee-drag-sort">
    <slot></slot>
  </div>
</template>
<script>
export default {
    name: 'LeeDragSort',
    inheritAttrs: false,
    data() {
        return {}
    },
    mounted() {
        setTimeout(() => {
            let targetAll = Array.from(document.querySelectorAll('.' + this.target))
            let draging, abs_x, abs_y, pos = [], offsetLeft, offsetTop
            targetAll.forEach((el) => {
                el.style.cssText = 'cursor: move;'
                pos.push({x: el.offsetLeft, y: el.offsetTop})
                //PC端
                el.addEventListener('mousedown', (e) => {
                    e.currentTarget.setAttribute('draggable', true)
                })
                el.addEventListener('dragstart', (e) => {
                    draging = e.currentTarget;
                })
                el.addEventListener('dragover', (e) => {
                    e.preventDefault()
                    let target = e.currentTarget;
                    //这段一定要放在元素改变位置前 begin
                    let targetRect = target.getBoundingClientRect();
                    let dragingRect = draging.getBoundingClientRect();
                    if (target) {
                        if (target.animated) {
                            return;
                        }
                    }
                    if (target !== draging) {
                        if (this.index(draging) < this.index(target)) {
                            this.inAfter(draging, target);
                        } else {
                            this.inBefore(draging, target);
                        }
                    }
                    //元素运动
                    this.animate(dragingRect, draging);
                    this.animate(targetRect, target);
                })
                el.addEventListener('dragend', function (e) {
                    e.currentTarget.removeAttribute('draggable');
                })
                //移动端
                el.addEventListener('touchstart', (e) => {
                    draging = e.currentTarget;
                    offsetLeft = draging.offsetLeft
                    offsetTop = draging.offsetTop
                    abs_x = e.targetTouches[0].pageX
                    abs_y = e.targetTouches[0].pageY

                })
                el.addEventListener('touchmove', (e) => {
                    e.preventDefault()
                    let target = e.currentTarget;
                    let halfw = target.offsetWidth / 2
                    let halfh = target.offsetHeight / 2
                    let left = e.targetTouches[0].pageX - abs_x + offsetLeft
                    let top = e.targetTouches[0].pageY - abs_y + offsetTop
                    //根据位置来insert
                    let jg = []
                    pos.forEach(function (el, index) {
                        jg.push({ix: index, x: left - el.x, y: top - el.y})
                    });
                    let xh;
                    let a = jg.filter(function (el) {
                        //return Math.abs(el.x) <= halfw && Math.abs(el.x) >= 0
                        return Math.abs(el.y) <= halfh && Math.abs(el.y) >= 0 && Math.abs(el.x) <= halfw && Math.abs(el.x) >= 0
                    });
                    let targetRect = target.getBoundingClientRect();
                    let dragingRect
                    if (a.length > 0) {
                        xh = a[0].ix
                        dragingRect = targetAll[xh].getBoundingClientRect();
                        if (target) {
                            if (target.animated) {
                                return;
                            }
                        }
                        if (e.targetTouches[0].pageY >= abs_y) {//下拖动
                            this.inAfter(draging, targetAll[xh]);
                            if (e.targetTouches[0].pageX < abs_x && Math.abs(a[0].x) >= halfw) {
                                //this.inBefore(draging, targetAll[xh]);
                            }
                        } else {
                            this.inBefore(draging, targetAll[xh]);
                            if (e.targetTouches[0].pageX >= abs_x && Math.abs(a[0].x) >= halfw) {
                                //this.inAfter(draging, targetAll[xh]);
                            }
                        }
                        this.animate(dragingRect, targetAll[xh]);
                        this.animate(targetRect, target);
                        targetAll = Array.from(document.querySelectorAll('.' + this.target))//要重置DOM
                    }
                })
            })
        }, 1)
    },
    props: {
        target: {
            type: String,
            default: '' //默认default
        }
    },
    methods: {
        index(target) {
            let xh = 0;
            let all = target.parentNode.children
            all = Array.from(all)
            xh = all.indexOf(target)
            return xh;
        },
        inAfter(newElement, targetElement) {
            let parent = targetElement.parentNode;
            parent.insertBefore(newElement, targetElement.nextSibling);
        },
        inBefore(newElement, targetElement) {
            let parent = targetElement.parentNode;
            parent.insertBefore(newElement, targetElement);
        },
        animate(prevRect, target) {
            let ms = 300;
            let currentRect = target.getBoundingClientRect();
            //我们先让元素立即回复之前拖动状态（insertAfter了，要先回到初始状态）
            target.style.cssText = "transition: none;transform: translate3D(" + (prevRect.left - currentRect.left) + "px," + (prevRect.top - currentRect.top) + "px,0)";
            target.offsetHeight; // 触发重绘
            //回到初始状态后开始变动拖动后位置动画
            target.style.cssText = "transition: all " + ms + "ms;transform: translateY(0px)";
            if (target.animated) { //如果元素在运动中，就不执行了
                return
            } else { //否者元素就给他运动属性，然后一段时间后再重新设置为false
                target.animated = true;
                setTimeout(function () {
                    target.style.cssText = "cursor: move;transition: '';transform: ''";
                    target.animated = false;
                }, ms);
            }
        }
    }
};
</script>
<style scoped>
.lee-drag-sort .lee-button {
  display: block;
  float: left;
}
.lee-drag-sort:before,.lee-drag-sort:after{
  content: '';
  display: table;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeDragSort.vue